import React from "react";
import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import { ActiveStatusProps } from "./interface";
const ActiveStatus = ({ isActive }: ActiveStatusProps) => {
  const { t } = useTranslation();

  const color = isActive ? "#0078F0" : "#F44336";

  return (
    <Tag color={color}>
      {isActive ? t("common.text.active") : t("common.text.inactive")}
    </Tag>
  );
};

export default ActiveStatus;
